import { z } from 'zod'
import { IataSchema, OpCoClassNameSchema } from './opCo'
import { SupportedLocaleEnum } from '../localisation'

export const PlatformTypeSchema = z.enum(['avios', 'whitelabel'])

export type PlatformType = z.infer<typeof PlatformTypeSchema>

export const PlatformThemeIdSchema = OpCoClassNameSchema.or(z.literal('avios'))

export type PlatformThemeId = z.infer<typeof PlatformThemeIdSchema>

export const PlatformBasePathSchema = z.string().refine((val) => {
  if (!val) {
    return true
  }
  const basePathRegex = /^\/[a-z][a-z0-9\-_/]*$/
  return basePathRegex.test(val)
})

export const PlatformConfigSchema = z.object({
  opCo: IataSchema,
  locale: SupportedLocaleEnum.default('en-GB'),
  market: z.string().default('GB'),
  theme: PlatformThemeIdSchema.default('avios'),
  basePath: PlatformBasePathSchema.optional(),
})

export type PlatformConfig = z.infer<typeof PlatformConfigSchema>
